var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"previewWrapper",staticClass:"preview-wrapper"},[_c('div',{staticClass:"device-border"},[_c('div',{staticClass:"device-preview-container",style:(_vm.containerStyle)},[_c('iframe',{staticClass:"scaled-iframe",style:(_vm.iframeStyle),attrs:{"src":_vm.getPreviewUrl(),"frameborder":"0"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }